import styled from 'styled-components'

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: ${props => props.flexStart ? 'flex-start' : 'center'};
  margin-bottom: 8px;
  ${props => props.bordered && 'border-top: 1px solid #999999; padding-top: 9px;'}
  ${props => props.flexWrap && 'flex-wrap: wrap; padding-left: 30px;'}
  ${props => props.fullWidth ? 'flex-basis: 100%;' : 'flex: 1;'}

  p {
    flex-basis: 100%;
    margin: 0px;
    color: #555555;
    font-family: 'Open Sans';
    font-size: 14px;
    font-weight: 400;

    span {
      font-weight: 600;
      font-size: 14px;
      color: #222222;
      font-family: 'Nunito';
    }

    strong {
      display: block;
      font-weight: 600;
      font-size: 14px;
      color: #222222;
      font-family: 'Nunito';
    }

  }
`

export const DataLabel = styled.span`
  margin-right: 20px;
  font-weight: 600;
  font-size: 14px;
  color: #999999;
  font-family: 'Open Sans';
`

export const CardContainer = styled.div`
  width: 100%;
  margin-bottom: 18px;
  margin-top: 7px;
  border: 1px solid #777777;
  border-radius: 4px 4px 0px 0px;
`

export const IconCircle = styled.div`
  background-color: #FAEAD0;
  border-radius: 100%;
  display: flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  width: 24px;
  min-width: 24px;
  height: 24px;
  min-height: 24px;

  img {
    width: 100%;
  }
`

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  left: 16px;
  line-height: 19.2px;
  background-color: ${props => props.backgroudColor ? props.backgroudColor : '#FF8200'};
  padding: 8px 10px;

  span {
    margin-left: 10px;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`

export const CardBody = styled.div`
  width: 100%;
  align-self: center;
  padding: 8px;
`

export const CardService = styled.div`
  text-align: center;
  background-color: ${props => props.serviceColor ? props.serviceColor : '#fff'};
  padding: 6.5px 70.5px 6.5px 70.5px;
  width: 100%;

  span {
    color: #555555;
    font-weight: 600;
    font-size: 16px;
    letter-spacing: 0.96px;
    font-family: 'Nunito';
  }
`

export const CardAdditionalService = styled(CardService)`
  padding: 6.5px 12px 6.5px 13px;

  span {
     display: -webkit-box;
    -webkit-box-orient: vertical;
    font-size: 14px;
    font-family: Open Sans;
    overflow: hidden;
    -webkit-line-clamp: 2;
  }
`
